import { createApp } from "vue";
import App from "./AppHengxing";
import router from "./router";

let app = createApp(App)

let defaultName = "恒星加速"
let appName = !(window.env && window.env.appName) ? defaultName : window.env.appName === '#{APPNAME}' ? defaultName :  window.env.appName
app.config.globalProperties.appName = appName

let defaultCompanyName = ""
let companyName = !(window.env && window.env.companyName) ? defaultCompanyName : window.env.companyName === '#{COMPANYNAME}' ? defaultCompanyName :  window.env.companyName
app.config.globalProperties.companyName = companyName


let defultEmail = 'viphelp724@gmail.com'
let email = !(window.env && window.env.supportEmail) ? defultEmail : window.env.supportEmail === '#{SUPPORTEMAIL}' ? defultEmail :  window.env.supportEmail
app.config.globalProperties.email = email;

let defaultSlogan = '秒开高清永不失联 <br> 像恒星一样稳定安全的加速器'
let slogan = !(window.env && window.env.slogan) ? defaultSlogan : window.env.slogan === '#{SLOGAN}' ? defaultSlogan :  window.env.slogan
app.config.globalProperties.slogan = slogan

window.document.title = appName

import utils from "./utils/utils"
utils.statsOpen()

app.use(router).mount("#app");

